var React = require('react');

function OpenMenu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"1","fill":"white","key":0}),React.createElement("rect",{"y":"11","width":"32","height":"1","fill":"white","key":1}),React.createElement("rect",{"x":"17","y":"22","width":"15","height":"1","fill":"white","key":2})]);
}

OpenMenu.defaultProps = {"width":"32","height":"23","viewBox":"0 0 32 23","fill":"none"};

module.exports = OpenMenu;

OpenMenu.default = OpenMenu;
